module.exports = __webpack_public_path__ + "img/38007061000153.6f3b35a9.png";